var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"motivos-anulacion"},[_c('AppMenu'),_c('BaseBreadcrumb',{attrs:{"title":"Motivos de anulación","breadcrumbs":_vm.breadcrumbs}}),_c('v-card',{staticClass:"mt-3 mx-3 pa-4"},[_c('MotivosDeAnulacion')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }